import React, { useState } from "react";
import { Wordmark } from "../Brand";

const linkGroups = [
  {
    title: "Platform",
    links: [
      { label: "About", href: "#about" },
      { label: "Services", href: "#services" },
      { label: "Membership", href: "#membership" },
      { label: "How it Works", href: "#how" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Blog", href: "#" },
      { label: "Founder Stories", href: "#" },
      { label: "Help Center", href: "#" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Careers", href: "https://forms.gle/ennQG62uWW65rYpk7" },
      { label: "Terms & Conditions", href: "/terms-and-conditions" },
      { label: "Privacy Policy", href: "/privacy-policy" },
    ],
  },
];

const socials = [
  { icon: "fa-brands fa-linkedin-in", url: "https://www.linkedin.com/company/india-business-helpline/", hoverBg: "#0A66C2" },
  { icon: "fa-brands fa-x-twitter", url: "https://x.com/ibh_info", hoverBg: "#1a1a1a" },
  { icon: "fa-brands fa-instagram", url: "https://www.instagram.com/indiabusinesshelpline/", hoverBg: "#E1306C" },
  { icon: "fa-brands fa-youtube", url: "https://www.youtube.com/@indiabusinesshelpline", hoverBg: "#FF0000" },
  { icon: "fa-brands fa-whatsapp", url: "https://wa.me/918274964884", hoverBg: "#25D366" },
  { icon: "fa-brands fa-facebook-f", url: "https://www.facebook.com/profile.php?id=61566777813226", hoverBg: "#1877F2" },
];

const SocialIcon = ({ icon, url, hoverBg }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? hoverBg : "rgba(255,255,255,0.08)",
        borderColor: hovered ? hoverBg : "rgba(255,255,255,0.10)",
        borderWidth: "1px",
        borderStyle: "solid",
        transition: "background-color 0.2s, border-color 0.2s",
      }}
      className="h-10 w-10 rounded-full flex items-center justify-center"
    >
      <i className={`${icon} text-sm text-white`}></i>
    </a>
  );
};

const Footer = () => {
  return (
    <footer
      id="contact"
      className="bg-ibh-navy text-white relative overflow-hidden"
      data-testid="footer"
    >
      <div className="absolute inset-0 grain mix-blend-overlay"></div>
      <div className="absolute -top-32 right-0 h-72 w-72 rounded-full bg-ibh-green/15 blur-3xl"></div>
      <div className="section relative pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Wordmark light context="footer" />
            <p className="mt-5 text-white/65 text-sm max-w-sm leading-relaxed">
              India Business Helpline (IBH) is the all-in-one ecosystem
              helping startups, MSMEs and entrepreneurs navigate every stage of
              business — with expert guidance and a powerful community.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {socials.map((s, i) => (
                <SocialIcon key={i} {...s} />
              ))}
            </div>
          </div>

          {linkGroups.map((g) => (
            <div key={g.title} className="lg:col-span-2">
           
<p className="font-display font-bold text-white text-sm uppercase tracking-wider">
  {g.title}
</p>
              <ul className="mt-5 space-y-3">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-white/65 hover:text-white transition-colors"
                      target={l.href.startsWith("http") ? "_blank" : undefined}
                      rel={l.href.startsWith("http") ? "noopener noreferrer" : undefined}
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
  <p className="font-display font-bold text-white text-sm uppercase tracking-wider">
    Contact
  </p>
  <ul className="mt-5 space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-envelope mt-1 text-ibh-green"></i>
                <a
                  href="mailto:indianbusinesshelpline@gmail.com"
                  className="hover:text-white transition-colors"
                >
                  Click to E-Mail
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-phone mt-1 text-ibh-green"></i>
                <a
                  href="tel:+918100301388"
                  className="hover:text-white transition-colors"
                >
                  +91 81003 01388
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-phone mt-1 text-ibh-green"></i>
                <a
                  href="tel:+918274964884"
                  className="hover:text-white transition-colors"
                >
                  +91 82749 64884
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-location-dot mt-1 text-ibh-green"></i>
                <a
                  href="https://maps.app.goo.gl/rnJSMm8raQDGcMGi8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Kolkata
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} India Business Helpline. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;